import $sflyOptimizely from "@sfly/uig-optimizely-wrapper-client/dist/index.js";

//init optimizely js wrapper
function initOptimizely() {
    if(!window.$sflyOptimizely) {
        window.initOptimizely();
    }
}

export function trackClick(type, uid) {
    initOptimizely();
    if(!uid || uid !== "" ) {
        uid = window.$omnitureDTL ? window.$omnitureDTL.getVisitorId() : 0;
    }
    try {
        return window.$sflyOptimizely.trackEvent(type, uid, {}, {});
    } catch {
        return Promise.reject(`Unable to track Optimizely event : ${type}`);
    }
}